/* eslint-disable max-statements */
/* eslint-disable complexity */
import formatData from '@/mixins/formatData';

export default {
    name: 'PositionStates',

    mixins: [ formatData ],

    /**
     * @override
     */
    data() {
        return {
            positionStatesTable: {},
            collapsed: true
        };
    },
    props: {
        data: {
            type: Array,
            required: false
        },
        loading: {
            type: Boolean,
            required: false
        }
    },
    watch: {
        /**
         * Actualizar registro de la tabla ante cambios en data
         */
        data() {
            this.formatData();
        }
    },
    methods: {

        /**
         * Formatea el objeto data
         */
        formatData() {
            if (!this.data || !Array.isArray(this.data) || this.data.length < 1) {
                this.$set(this.positionStatesTable, 'items', []);
                return;
            }
            this.$set(this.positionStatesTable, 'items', this.data.map(i => i));
        }
    },
    /**
     * @override
     */
    beforeMount() {
        this.positionStatesTable = {
            fields: [
                { key: 'name_product', label: 'Producto', tdClass: 'color-brand' },
                { key: 'nav_date', label: 'Fecha V.L' },
                { key: 'shares', label: 'Participaciones' },
                { key: 'nav', label: 'V.L Actual' },
                { key: 'purchase_amount', label: 'Imp. Compra' },
                { key: 'average_nav', label: 'V.L. Medio' },
                { key: "current_amount", label: "Valoración" },
                { key: 'difference', label: 'Revalorización' },
                { key: 'profitability', label: 'Rentabilidad' }
            ]
        };
    }
};
